module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/internal/internal.component.css
// module id = ./src/app/issues/internal/internal.component.css
// module chunks = main